import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CsrWebApiService } from '../../../../csr-web-api.service';
import { CareerRoleSummaryListItemResponse } from '../../../../models';
import {
  CareerRoleListComponent,
  CareerRoleListQuery
} from '../../career-role-list/career-role-list.component';
import { CareerRoleAdminActionsService } from '../shared/career-role-admin-actions.service';

@Component({
  selector: 'app-career-role-list-view',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    MatSnackBarModule,
    CareerRoleListComponent
  ],
  templateUrl: './career-role-list-view.component.html',
  styleUrl: './career-role-list-view.component.scss'
})
export class CareerRoleListViewComponent {
  private readonly api = inject(CsrWebApiService);
  private readonly actions = inject(CareerRoleAdminActionsService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly router = inject(Router);

  loading = false;
  roleItems: CareerRoleSummaryListItemResponse[] = [];
  roleListCount = 0;
  private lastQuery: CareerRoleListQuery = { page: 1, pageSize: 10, activeOnly: false };

  async loadRoles(query: CareerRoleListQuery): Promise<void> {
    this.lastQuery = query;
    this.loading = true;
    try {
      const response = await firstValueFrom(
        this.api.listCareerRolesLight(query.page, query.pageSize, query.searchText, query.activeOnly)
      );
      this.roleItems = response.data;
      this.roleListCount = response.count;
    } catch (error) {
      this.snackBar.open(this.actions.errorMessage(error), 'Close', { duration: 3200 });
    } finally {
      this.loading = false;
    }
  }

  openRole(slug: string): void {
    void this.router.navigate(['/admin/career-roles', slug]);
  }

  async createRoleWithAi(): Promise<void> {
    const roleName = window.prompt('Enter the name of the new Career Role to generate:');
    if (!roleName?.trim()) {
      return;
    }
    this.loading = true;
    try {
      await this.actions.createRoleWithAi(roleName.trim());
      await this.reloadLastQuery();
    } catch (error) {
      this.snackBar.open(this.actions.errorMessage(error), 'Close', { duration: 3200 });
    } finally {
      this.loading = false;
    }
  }

  private async reloadLastQuery(): Promise<void> {
    const response = await firstValueFrom(
      this.api.listCareerRolesLight(this.lastQuery.page, this.lastQuery.pageSize, this.lastQuery.searchText, this.lastQuery.activeOnly)
    );
    this.roleItems = response.data;
    this.roleListCount = response.count;
  }
}